export const REFUNDS_METHODS = {
  stored_credit: 'storedCredit',
  payment_source: 'paymentSource',
};
